/**
 * Typed testid registry for the `navbar` domain.
 *
 * Components spread these values into `data-testid`; Playwright specs import the
 * SAME object for their selectors, so a rename moves both sides together instead
 * of failing at runtime with "element not found" (e2e is not run in CI, so that
 * drift fails silently). The `teselly/no-raw-testid` ESLint rule forbids raw
 * `data-testid` literals under `src/apps/web-app/**`, so new testids land here.
 *
 * Naming convention: `<area>-[section]-[element]` in kebab-case — see
 * `.claude/rules/e2e-testing.md`.
 */
export const navbarTestIds = {
  // --- UserNavbar / ObservationModePill (Observation Mode, ADR-068) ---
  /** The pill itself. Absent from the DOM entirely when the account is live. */
  observationPill: 'navbar-observation-pill',
  /** The pill's text label (hidden by CSS below `sm`, still in the DOM). */
  observationPillLabel: 'navbar-observation-pill-label',
  /** Popover body, present only while the popover is open. */
  observationPopover: 'navbar-observation-popover',
  /** The go-live action. Rendered but disabled until GoLive is tenant-facing. */
  observationGoLiveButton: 'navbar-observation-go-live-button',
  /** Explanation of why the go-live action is not available yet. */
  observationGoLiveHint: 'navbar-observation-go-live-hint'
} as const;
